import { Component, OnDestroy, OnInit } from "@angular/core";
import { UserHttpClientService } from "../../../data/user-http-client.service";
import { IWalletOverview, WalletOverview } from "../../../models/User/user-wallet";
import { Subscription } from "rxjs/internal/Subscription";
import { Router } from "@angular/router";
import { User } from "src/app/models/User/user";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-wallet-list",
    templateUrl: "./wallet-list.component.html",
    styleUrls: ["./wallet-list.component.css"]
})
export class WalletListComponent implements OnInit, OnDestroy {

    // #region Subscriptions
    userWallets$ = new Subscription();
    // #endregion

    wallets = [] as IWalletOverview[];
    selectedWallet = new WalletOverview();

    isAuthorized: boolean

    constructor(private userHttpClient: UserHttpClientService, private route: Router, private translateService: TranslateService) {
    }

    ngOnInit() {
        this.userWallets$ = this.userHttpClient.getWalletOverview()
            .subscribe(
                {
                    next: (wallets) => {
                        this.wallets = wallets.map(item => new WalletOverview(item))
                        this.selectedWallet = new WalletOverview(wallets[0]);
                    }
                }
            );
        this.userHttpClient.getUserDetails().subscribe((user: User) => {
            this.isAuthorized = user.is_authorized;
        });
    }

    compareDate(crDate: Date, dbDate: Date): Date {
        return crDate > dbDate ? crDate : dbDate;
    }

    changeSelectedWallet(index: number) {
        this.selectedWallet = new WalletOverview(this.wallets[index]);
    }

    isSelected = (walletId: number): boolean => walletId === this.selectedWallet.walletId;

    isDefaultDate(walletDate: Date): boolean {
        return walletDate.getFullYear() === 1970;
    }

    ngOnDestroy() {
        this.userWallets$.unsubscribe();
    }

    onChangeRouteToHistoryOfTransaction(event: MouseEvent) {
        event.stopPropagation();
        this.route.navigate(["transaction-history"]);
    }
}
